export interface ComicChapter {
  id: number;
  title: string;
  number: number;
  date: string;
}

export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  description: string;
  rating: number;
  updateDate: string;
  chapters: ComicChapter[];
  isHot: boolean;
  isNew: boolean;
  views: number;
  tags: string[];
}

export const categories = [
  { slug: 'all', name: '全部漫画', icon: 'ri-apps-2-line' },
  { slug: 'romance', name: '恋爱言情', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻冒险', icon: 'ri-magic-line' },
  { slug: 'action', name: '热血动作', icon: 'ri-fire-line' },
  { slug: 'comedy', name: '搞笑日常', icon: 'ri-emotion-laugh-line' },
  { slug: 'drama', name: '剧情悬疑', icon: 'ri-movie-2-line' },
  { slug: 'thriller', name: '惊悚恐怖', icon: 'ri-ghost-line' },
  { slug: 'bl', name: 'BL漫画', icon: 'ri-star-line' },
  { slug: 'gl', name: 'GL漫画', icon: 'ri-hearts-line' },
  { slug: 'completed', name: '已完结', icon: 'ri-check-double-line' },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: '恋爱革命',
    author: '232',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20romance%20cover%20art%20featuring%20a%20young%20couple%20on%20a%20cherry%20blossom%20campus%20path%2C%20soft%20pastel%20colors%2C%20romantic%20atmosphere%2C%20anime%20art%20style%2C%20clean%20minimal%20background%20with%20spring%20petals%20falling%2C%20warm%20lighting%2C%20high%20quality%20illustration%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    category: 'romance',
    description: '平凡的校园生活因为一个特别的转学生而彻底改变。王子琳原本过着平静的高中生活，直到那个叫周叙的男生出现在她的世界里。帅气、聪明、却又神秘莫测的他，让她的心跳开始不受控制。这是一段关于青春、成长和初恋的故事，甜蜜中带着些许酸涩，令人回味无穷。',
    rating: 9.5,
    updateDate: '2026-08-04',
    chapters: [
      { id: 101, title: '第101话 最后的告白', number: 101, date: '2026-08-04' },
      { id: 100, title: '第100话 心动的答案', number: 100, date: '2026-07-28' },
      { id: 99, title: '第99话 雨中的约定', number: 99, date: '2026-07-21' },
      { id: 98, title: '第98话 深夜的讯息', number: 98, date: '2026-07-14' },
      { id: 97, title: '第97话 意外的相遇', number: 97, date: '2026-07-07' },
    ],
    isHot: true,
    isNew: false,
    views: 2856000,
    tags: ['校园', '初恋', '甜宠', '青春'],
  },
  {
    id: 2,
    title: '暗夜君主',
    author: '金泰亨',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20Korean%20manhwa%20cover%20featuring%20a%20mysterious%20warrior%20in%20black%20armor%20holding%20a%20glowing%20sword%2C%20medieval%20gothic%20setting%2C%20dramatic%20moonlight%2C%20dark%20purple%20and%20crimson%20accents%2C%20anime%20art%20style%2C%20epic%20fantasy%20atmosphere%2C%20detailed%20illustration%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    category: 'fantasy',
    description: '在一个被黑暗势力笼罩的王国里，年轻的骑士艾利克斯背负着家族的秘密使命。他必须在光明与黑暗之间做出选择，而隐藏在血脉中的力量正在觉醒。当他发现自己的真实身份后，整个世界的命运都将因此而改变。充满史诗感的战斗场面和错综复杂的权力斗争。',
    rating: 9.7,
    updateDate: '2026-08-03',
    chapters: [
      { id: 86, title: '第86话 觉醒之力', number: 86, date: '2026-08-03' },
      { id: 85, title: '第85话 王座之争', number: 85, date: '2026-07-27' },
      { id: 84, title: '第84话 龙之契约', number: 84, date: '2026-07-20' },
      { id: 83, title: '第83话 暗影来袭', number: 83, date: '2026-07-13' },
      { id: 82, title: '第82话 剑与魔法', number: 82, date: '2026-07-06' },
    ],
    isHot: true,
    isNew: false,
    views: 4230000,
    tags: ['奇幻', '战斗', '冒险', '史诗'],
  },
  {
    id: 3,
    title: '便利店新星',
    author: '李智慧',
    cover: 'https://readdy.ai/api/search-image?query=A%20cute%20Korean%20manhwa%20cover%20showing%20a%20cheerful%20convenience%20store%20worker%20girl%20wearing%20uniform%20behind%20the%20counter%2C%20bright%20and%20warm%20color%20palette%2C%20slice%20of%20life%20vibe%2C%20anime%20art%20style%2C%20friendly%20atmosphere%2C%20clean%20background%20with%20store%20shelves%2C%20high%20quality%20illustration%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    category: 'comedy',
    description: '失业青年金志浩迫于生计来到一家便利店打工，却不料这家小小的便利店里卧虎藏龙。从神秘的店长到古怪的常客，每一天都充满了意想不到的笑料和温暖。这是一部让人捧腹大笑又感动落泪的日常喜剧，展现了普通人的不平凡生活。',
    rating: 9.3,
    updateDate: '2026-08-05',
    chapters: [
      { id: 63, title: '第63话 夜班奇遇', number: 63, date: '2026-08-05' },
      { id: 62, title: '第62话 特价促销日', number: 62, date: '2026-07-29' },
      { id: 61, title: '第61话 神秘包裹', number: 61, date: '2026-07-22' },
      { id: 60, title: '第60话 新员工训练', number: 60, date: '2026-07-15' },
      { id: 59, title: '第59话 深夜来客', number: 59, date: '2026-07-08' },
    ],
    isHot: false,
    isNew: true,
    views: 1560000,
    tags: ['日常', '搞笑', '治愈', '职场'],
  },
  {
    id: 4,
    title: '第七个夜晚',
    author: '郑多云',
    cover: 'https://readdy.ai/api/search-image?query=A%20thriller%20Korean%20manhwa%20cover%20showing%20a%20woman%20with%20fearful%20expression%20in%20a%20dark%20alleyway%2C%20mysterious%20shadow%20behind%20her%2C%20cold%20blue%20and%20dark%20gray%20tones%2C%20suspenseful%20atmosphere%2C%20anime%20art%20style%2C%20rain%20falling%2C%20cinematic%20lighting%2C%20thriller%20mystery%20vibe%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    category: 'thriller',
    description: '连续七天的夜晚，城市中接连发生离奇的失踪案件。刚调任的刑警韩素希发现这些案件之间存在着诡异的联系——所有失踪者最后出现的地点，都指向一栋废弃多年的老宅。随着调查的深入，她逐渐揭开了一个令人毛骨悚然的真相，而她自己也可能成为下一个目标。',
    rating: 9.6,
    updateDate: '2026-08-02',
    chapters: [
      { id: 45, title: '第45话 真相浮现', number: 45, date: '2026-08-02' },
      { id: 44, title: '第44话 地下室', number: 44, date: '2026-07-26' },
      { id: 43, title: '第43话 目击者', number: 43, date: '2026-07-19' },
      { id: 42, title: '第42话 第六天', number: 42, date: '2026-07-12' },
      { id: 41, title: '第41话 关键线索', number: 41, date: '2026-07-05' },
    ],
    isHot: true,
    isNew: false,
    views: 1980000,
    tags: ['悬疑', '推理', '犯罪', '惊悚'],
  },
  {
    id: 5,
    title: '武林至尊',
    author: '朴武烈',
    cover: 'https://readdy.ai/api/search-image?query=A%20martial%20arts%20Korean%20manhwa%20cover%20featuring%20a%20young%20swordsman%20in%20traditional%20hanbok%20standing%20on%20a%20mountain%20cliff%2C%20moonlit%20night%2C%20flowing%20robes%2C%20dynamic%20pose%2C%20anime%20art%20style%2C%20epic%20wuxia%20vibe%2C%20traditional%20Korean%20landscape%2C%20dramatic%20composition%2C%20vertical%20portrait&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    category: 'action',
    description: '少年姜云为了替被陷害的师父报仇，独自踏入江湖。在这个强者为尊的武林世界，他凭借着过人的天赋和不懈的努力，一步步从无名小卒成长为一代宗师。热血的战斗场面、深厚的师徒情谊、以及江湖中的恩怨情仇，构成了这部恢弘的武侠巨作。',
    rating: 9.4,
    updateDate: '2026-08-04',
    chapters: [
      { id: 122, title: '第122话 巅峰对决', number: 122, date: '2026-08-04' },
      { id: 121, title: '第121话 师门大会', number: 121, date: '2026-07-28' },
      { id: 120, title: '第120话 绝地反击', number: 120, date: '2026-07-21' },
      { id: 119, title: '第119话 秘密修炼', number: 119, date: '2026-07-14' },
      { id: 118, title: '第118话 故人重逢', number: 118, date: '2026-07-07' },
    ],
    isHot: true,
    isNew: false,
    views: 3420000,
    tags: ['武侠', '热血', '江湖', '修炼'],
  },
  {
    id: 6,
    title: '完美谎言',
    author: '韩美英',
    cover: 'https://readdy.ai/api/search-image?query=A%20drama%20Korean%20manhwa%20cover%20showing%20two%20people%20facing%20away%20from%20each%20other%20in%20a%20rainy%20city%20street%2C%20melancholic%20atmosphere%2C%20muted%20warm%20tones%2C%20emotional%20distance%20portrayed%2C%20anime%20art%20style%2C%20dramatic%20lighting%2C%20reflection%20in%20puddles%2C%20heartfelt%20mood%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    category: 'drama',
    description: '顶级律师朴智恩在法庭上战无不胜，却在个人生活中陷入了一个精心编织的谎言网。当她的丈夫突然失踪，留下的只有一本密码日记。为了揭开真相，她必须面对自己过去的每一个选择。这是一部关于婚姻、背叛和救赎的心理剧情漫画，每一页都扣人心弦。',
    rating: 9.2,
    updateDate: '2026-08-01',
    chapters: [
      { id: 78, title: '第78话 最后的证据', number: 78, date: '2026-08-01' },
      { id: 77, title: '第77话 日记密码', number: 77, date: '2026-07-25' },
      { id: 76, title: '第76话 证人席', number: 76, date: '2026-07-18' },
      { id: 75, title: '第75话 双重身份', number: 75, date: '2026-07-11' },
      { id: 74, title: '第74话 旧友来访', number: 74, date: '2026-07-04' },
    ],
    isHot: false,
    isNew: false,
    views: 1240000,
    tags: ['都市', '悬疑', '婚姻', '心理'],
  },
  {
    id: 7,
    title: '星之彼方',
    author: '柳星河',
    cover: 'https://readdy.ai/api/search-image?query=A%20sci-fi%20fantasy%20Korean%20manhwa%20cover%20showing%20a%20young%20girl%20with%20star-like%20hair%20floating%20in%20space%2C%20galaxy%20background%2C%20ethereal%20glow%2C%20dreamy%20pastel%20colors%2C%20anime%20art%20style%2C%20cosmic%20atmosphere%2C%20magical%20girl%20theme%2C%20luminous%20details%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    category: 'fantasy',
    description: '在一个遥远的星际文明中，少女星璃拥有一项特殊能力——她可以用歌声操控星辰。当银河帝国开始崩塌，她成为了拯救整个星系的关键。与来自不同星球的伙伴们一起，她踏上了寻找遗失星图的冒险旅程。',
    rating: 9.1,
    updateDate: '2026-08-05',
    chapters: [
      { id: 54, title: '第54话 银河之心', number: 54, date: '2026-08-05' },
      { id: 53, title: '第53话 星图碎片', number: 53, date: '2026-07-29' },
      { id: 52, title: '第52话 异星访客', number: 52, date: '2026-07-22' },
      { id: 51, title: '第51话 黑洞边缘', number: 51, date: '2026-07-15' },
      { id: 50, title: '第50话 宇宙歌姬', number: 50, date: '2026-07-08' },
    ],
    isHot: false,
    isNew: true,
    views: 890000,
    tags: ['科幻', '星际', '冒险', '音乐'],
  },
  {
    id: 8,
    title: '禁忌之恋',
    author: '安美京',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20BL%20Korean%20manhwa%20cover%20featuring%20two%20handsome%20young%20men%20standing%20close%20under%20cherry%20blossom%20trees%2C%20soft%20pink%20and%20white%20color%20palette%2C%20gentle%20eye%20contact%2C%20anime%20art%20style%2C%20romantic%20spring%20atmosphere%2C%20elegant%20composition%2C%20tender%20mood%2C%20vertical%20portrait&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    category: 'bl',
    description: '继承了家族企业的财阀继承人尹泰俊，在一次偶然的机会下认识了街头画家成浩。两个来自完全不同世界的人，却被命运紧紧联系在一起。在家族压力和社会偏见面前，他们的爱情能否经得起考验？',
    rating: 9.4,
    updateDate: '2026-08-03',
    chapters: [
      { id: 67, title: '第67话 家族会议', number: 67, date: '2026-08-03' },
      { id: 66, title: '第66话 画展之夜', number: 66, date: '2026-07-27' },
      { id: 65, title: '第65话 海边旅行', number: 65, date: '2026-07-20' },
      { id: 64, title: '第64话 初雪告白', number: 64, date: '2026-07-13' },
      { id: 63, title: '第63话 意外的吻', number: 63, date: '2026-07-06' },
    ],
    isHot: true,
    isNew: false,
    views: 2670000,
    tags: ['BL', '都市', '财阀', '浪漫'],
  },
  {
    id: 9,
    title: '月光花园',
    author: '崔秀雅',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20GL%20Korean%20manhwa%20cover%20showing%20two%20young%20women%20in%20a%20moonlit%20garden%2C%20holding%20hands%2C%20flowers%20blooming%20around%20them%2C%20soft%20silver%20and%20lavender%20tones%2C%20anime%20art%20style%2C%20romantic%20night%20atmosphere%2C%20gentle%20expressions%2C%20elegant%20dresses%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    category: 'gl',
    description: '花艺师素英经营着一家小小的花店，生活平静而单调。直到有一天，一位神秘的女顾客每周都会来买同一束花。月光下的花园成为了她们秘密约会的场所，一段美丽而纯粹的感情在花语中悄然绽放。',
    rating: 9.3,
    updateDate: '2026-08-04',
    chapters: [
      { id: 39, title: '第39话 花语告白', number: 39, date: '2026-08-04' },
      { id: 38, title: '第38话 秘密花园', number: 38, date: '2026-07-28' },
      { id: 37, title: '第37话 白色郁金香', number: 37, date: '2026-07-21' },
      { id: 36, title: '第36话 雨天咖啡', number: 36, date: '2026-07-14' },
      { id: 35, title: '第35话 初次相遇', number: 35, date: '2026-07-07' },
    ],
    isHot: false,
    isNew: true,
    views: 1030000,
    tags: ['GL', '唯美', '花语', '日常'],
  },
  {
    id: 10,
    title: '重生之影后归来',
    author: '金秀贤',
    cover: 'https://readdy.ai/api/search-image?query=A%20glamorous%20Korean%20manhwa%20cover%20showing%20a%20beautiful%20actress%20on%20a%20red%20carpet%2C%20flashy%20spotlight%2C%20elegant%20evening%20gown%2C%20confident%20expression%2C%20anime%20art%20style%2C%20celebrity%20theme%2C%20dramatic%20lighting%2C%20luxurious%20atmosphere%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    category: 'drama',
    description: '曾经的顶级影后沈秀晶在一场阴谋中失去了一切，却意外重生回到了十年前。带着前世的记忆和经验，她决心改写自己的命运，向那些背叛过她的人一一复仇。但在复仇的路上，她遇到了一个让她无法忽视的人。',
    rating: 9.6,
    updateDate: '2026-08-05',
    chapters: [
      { id: 91, title: '第91话 颁奖典礼', number: 91, date: '2026-08-05' },
      { id: 90, title: '第90话 幕后黑手', number: 90, date: '2026-07-29' },
      { id: 89, title: '第89话 新片试镜', number: 89, date: '2026-07-22' },
      { id: 88, title: '第88话 旧敌重逢', number: 88, date: '2026-07-15' },
      { id: 87, title: '第87话 命运的转折', number: 87, date: '2026-07-08' },
    ],
    isHot: true,
    isNew: false,
    views: 3780000,
    tags: ['重生', '娱乐圈', '复仇', '逆袭'],
  },
  {
    id: 11,
    title: '妖怪公寓',
    author: '张瑞元',
    cover: 'https://readdy.ai/api/search-image?query=A%20supernatural%20comedy%20Korean%20manhwa%20cover%20showing%20various%20cute%20monsters%20and%20a%20human%20protagonist%20in%20a%20modern%20apartment%2C%20colorful%20and%20playful%2C%20anime%20art%20style%2C%20fun%20atmosphere%2C%20slice%20of%20life%20mixed%20with%20fantasy%2C%20bright%20interior%20setting%2C%20vertical%20portrait&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    category: 'comedy',
    description: '大学生李敏浩因为房租便宜，搬进了一栋看起来普通的公寓楼。然而他很快发现，这栋楼里的其他住户全部都是妖怪！从吸血鬼房东到九尾狐邻居，每一天都在发生令人啼笑皆非的怪事。一部融合了搞笑与温情的超自然日常喜剧。',
    rating: 9.0,
    updateDate: '2026-08-02',
    chapters: [
      { id: 58, title: '第58话 万圣节派对', number: 58, date: '2026-08-02' },
      { id: 57, title: '第57话 新邻居是猫妖', number: 57, date: '2026-07-26' },
      { id: 56, title: '第56话 九尾狐的烦恼', number: 56, date: '2026-07-19' },
      { id: 55, title: '第55话 吸血鬼的便当', number: 55, date: '2026-07-12' },
      { id: 54, title: '第54话 搬家的第一天', number: 54, date: '2026-07-05' },
    ],
    isHot: false,
    isNew: false,
    views: 1120000,
    tags: ['奇幻', '搞笑', '日常', '治愈'],
  },
  {
    id: 12,
    title: '剑影随行',
    author: '尹剑豪',
    cover: 'https://readdy.ai/api/search-image?query=A%20action%20Korean%20manhwa%20cover%20showing%20a%20female%20swordswoman%20in%20dynamic%20fighting%20pose%2C%20wind%20blowing%20her%20hair%2C%20sword%20gleaming%2C%20cherry%20blossom%20petals%20in%20motion%2C%20anime%20art%20style%2C%20historical%20Korean%20setting%2C%20dramatic%20action%20composition%2C%20vertical%20portrait&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    category: 'action',
    description: '被誉为"剑术天才"的少女华英，在师父离世后独自追寻剑道的极致。她的剑如影随形，快若闪电。在这个男尊女卑的时代，她以实力证明女子也能成为天下第一剑客。精彩绝伦的剑术对决和感人至深的成长故事。',
    rating: 9.5,
    updateDate: '2026-08-03',
    chapters: [
      { id: 48, title: '第48话 天下第一剑', number: 48, date: '2026-08-03' },
      { id: 47, title: '第47话 华山论剑', number: 47, date: '2026-07-27' },
      { id: 46, title: '第46话 宿敌之战', number: 46, date: '2026-07-20' },
      { id: 45, title: '第45话 密林修炼', number: 45, date: '2026-07-13' },
      { id: 44, title: '第44话 师父遗训', number: 44, date: '2026-07-06' },
    ],
    isHot: false,
    isNew: true,
    views: 1780000,
    tags: ['武侠', '女性主角', '剑术', '冒险'],
  },
  {
    id: 13,
    title: '甜蜜的陷阱',
    author: '宋佳人',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20comedy%20Korean%20manhwa%20cover%20showing%20a%20couple%20baking%20together%20in%20a%20cozy%20kitchen%2C%20flour%20on%20their%20noses%2C%20laughing%2C%20warm%20golden%20lighting%2C%20anime%20art%20style%2C%20sweet%20atmosphere%2C%20pastry%20shop%20setting%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-13&orientation=portrait',
    category: 'romance',
    description: '甜点师崔允儿在一次厨艺比赛中遇到了冷酷的评审——知名美食评论家权时宇。他挑剔的味蕾和毒舌的评价让她又气又恼，但不知不觉中，这份对立变成了微妙的吸引。当甜蜜的甜点遇上辛辣的点评，爱情的味道究竟是什么样的？',
    rating: 9.2,
    updateDate: '2026-08-01',
    chapters: [
      { id: 56, title: '第56话 甜蜜的秘密', number: 56, date: '2026-08-01' },
      { id: 55, title: '第55话 厨艺对决', number: 55, date: '2026-07-25' },
      { id: 54, title: '第54话 隐藏的温柔', number: 54, date: '2026-07-18' },
      { id: 53, title: '第53话 失败的甜点', number: 53, date: '2026-07-11' },
      { id: 52, title: '第52话 初次见面', number: 52, date: '2026-07-04' },
    ],
    isHot: false,
    isNew: false,
    views: 1450000,
    tags: ['恋爱', '美食', '职场', '甜宠'],
  },
  {
    id: 14,
    title: '末日后记',
    author: '韩振宇',
    cover: 'https://readdy.ai/api/search-image?query=A%20post-apocalyptic%20Korean%20manhwa%20cover%20showing%20a%20survivor%20in%20ruined%20city%2C%20wearing%20protective%20gear%2C%20holding%20a%20weapon%2C%20gray%20overcast%20sky%2C%20anime%20art%20style%2C%20desolate%20atmosphere%2C%20dramatic%20lighting%20through%20broken%20buildings%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-14&orientation=portrait',
    category: 'thriller',
    description: '一场突如其来的病毒爆发让世界陷入混乱。幸存者们在一片废墟中艰难求生，但最可怕的不是那些变异生物，而是人性在绝境中的扭曲。几个陌生人在求生路上相遇，他们能否守住最后的良知，还是会被这个世界吞噬？',
    rating: 9.4,
    updateDate: '2026-08-04',
    chapters: [
      { id: 72, title: '第72话 安全区', number: 72, date: '2026-08-04' },
      { id: 71, title: '第71话 幸存者营地', number: 71, date: '2026-07-28' },
      { id: 70, title: '第70话 地下通道', number: 70, date: '2026-07-21' },
      { id: 69, title: '第69话 变异之夜', number: 69, date: '2026-07-14' },
      { id: 68, title: '第68话 末日的开始', number: 68, date: '2026-07-07' },
    ],
    isHot: true,
    isNew: false,
    views: 2340000,
    tags: ['末世', '生存', '人性', '丧尸'],
  },
  {
    id: 15,
    title: '花与荆棘',
    author: '林允儿',
    cover: 'https://readdy.ai/api/search-image?query=A%20completed%20romance%20Korean%20manhwa%20cover%20showing%20a%20happy%20couple%20embracing%20in%20a%20field%20of%20wildflowers%2C%20sunset%20golden%20light%2C%20fulfilling%20ending%20vibe%2C%20anime%20art%20style%2C%20warm%20and%20peaceful%20atmosphere%2C%20completed%20story%20feeling%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-15&orientation=portrait',
    category: 'completed',
    description: '从小在孤儿院长大的双胞胎姐妹，在十八岁那年被不同的家庭收养，命运从此分道扬镳。姐姐入豪门，妹妹入寒门。十年后，当她们再次相遇，各自的人生已经天差地别。一部关于亲情、成长和宽恕的感人故事。',
    rating: 9.8,
    updateDate: '2026-07-15',
    chapters: [
      { id: 120, title: '第120话 最终章 重逢（完结）', number: 120, date: '2026-07-15' },
      { id: 119, title: '第119话 姐妹', number: 119, date: '2026-07-08' },
      { id: 118, title: '第118话 和解', number: 118, date: '2026-07-01' },
      { id: 117, title: '第117话 真相大白', number: 117, date: '2026-06-24' },
      { id: 116, title: '第116话 危机时刻', number: 116, date: '2026-06-17' },
    ],
    isHot: false,
    isNew: false,
    views: 5120000,
    tags: ['完结', '亲情', '成长', '治愈'],
  },
  {
    id: 16,
    title: '魔女狩猎',
    author: '权志龙',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20thriller%20Korean%20manhwa%20cover%20showing%20a%20mysterious%20woman%20with%20magical%20powers%20surrounded%20by%20flames%2C%20medieval%20setting%2C%20witch%20hunt%20theme%2C%20anime%20art%20style%2C%20dramatic%20fire%20lighting%2C%20intense%20atmosphere%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-16&orientation=portrait',
    category: 'thriller',
    description: '在中世纪的王国里，一股猎杀女巫的狂潮席卷全国。炼金术士塞拉被迫隐藏自己的身份，但她体内的魔力正在失控。当猎巫人追查到她的踪迹，她必须在死亡与反抗之间做出选择。黑暗而紧张的氛围让人无法移开视线。',
    rating: 9.1,
    updateDate: '2026-08-02',
    chapters: [
      { id: 34, title: '第34话 审判日', number: 34, date: '2026-08-02' },
      { id: 33, title: '第33话 火刑柱', number: 33, date: '2026-07-26' },
      { id: 32, title: '第32话 地下组织', number: 32, date: '2026-07-19' },
      { id: 31, title: '第31话 炼金术的秘密', number: 31, date: '2026-07-12' },
      { id: 30, title: '第30话 猎巫人到来', number: 30, date: '2026-07-05' },
    ],
    isHot: false,
    isNew: false,
    views: 980000,
    tags: ['中世纪', '魔法', '黑暗', '冒险'],
  },
];

export const hotComics = comics.filter(c => c.isHot);
export const newComics = comics.filter(c => c.isNew);
export const completedComics = comics.filter(c => c.category === 'completed');

export const heroSlides = [
  {
    id: 1,
    comicId: 1,
    title: '恋爱革命 - 青春校园恋爱巅峰之作',
    subtitle: '累计阅读量突破285万，评分9.5的校园恋爱神作',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20romance%20scene%20banner%2C%20young%20couple%20walking%20under%20cherry%20blossom%20trees%20on%20a%20school%20campus%2C%20spring%20petals%20falling%2C%20soft%20warm%20golden%20sunset%20light%2C%20anime%20art%20style%2C%20romantic%20dreamy%20atmosphere%2C%20cinematic%20wide%20composition%2C%20pastel%20pink%20and%20warm%20orange%20tones&width=1400&height=600&seq=hero-slide-01&orientation=landscape',
  },
  {
    id: 2,
    comicId: 5,
    title: '武林至尊 - 热血武侠史诗巨制',
    subtitle: '累计阅读量突破342万，武侠韩漫排行榜TOP3',
    cover: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20martial%20arts%20manhwa%20banner%20scene%2C%20warrior%20standing%20on%20mountain%20peak%20at%20sunrise%2C%20traditional%20Korean%20landscape%20with%20mist%20and%20pine%20trees%2C%20epic%20cinematic%20wide%20shot%2C%20anime%20art%20style%2C%20warm%20golden%20morning%20light%2C%20heroic%20atmosphere&width=1400&height=600&seq=hero-slide-02&orientation=landscape',
  },
  {
    id: 3,
    comicId: 10,
    title: '重生之影后归来 - 娱乐圈逆袭爽文',
    subtitle: '累计阅读量突破378万，重生复仇题材扛鼎之作',
    cover: 'https://readdy.ai/api/search-image?query=A%20glamorous%20Korean%20manhwa%20banner%20showing%20a%20beautiful%20actress%20on%20stage%20receiving%20an%20award%2C%20spotlight%20and%20confetti%2C%20elegant%20atmosphere%2C%20anime%20art%20style%2C%20dramatic%20cinematic%20wide%20shot%2C%20warm%20golden%20stage%20lighting%2C%20triumphant%20mood&width=1400&height=600&seq=hero-slide-03&orientation=landscape',
  },
];

export const testimonials = [
  {
    id: 1,
    name: '小雨',
    avatar: '',
    rating: 5,
    comment: '这是我用过最好的韩漫网站！更新速度超快，画质清晰，而且完全免费。每天打开手机第一件事就是看看有没有更新，已经成为生活习惯了。',
    date: '2026-07-28',
  },
  {
    id: 2,
    name: '漫画迷阿星',
    avatar: '',
    rating: 5,
    comment: '分类很全面，找漫画特别方便。之前在其他平台追的漫画这里都有，而且更新比官方还快。强烈推荐给所有喜欢韩漫的朋友！',
    date: '2026-07-25',
  },
  {
    id: 3,
    name: '夜雨声烦',
    avatar: '',
    rating: 4,
    comment: '网站设计简洁大方，阅读体验很好。收藏了很多部连载中的漫画，每天都有更新提醒。希望以后可以加入更多完结漫画的资源。',
    date: '2026-07-22',
  },
  {
    id: 4,
    name: '樱花树下',
    avatar: '',
    rating: 5,
    comment: '从朋友那里知道这个网站的，一用就爱上了。漫画种类丰富，翻译质量也很高。最重要的是不用注册就能看，太方便了！',
    date: '2026-07-20',
  },
  {
    id: 5,
    name: '追漫少年',
    avatar: '',
    rating: 5,
    comment: '宝藏网站！一直很喜欢韩国漫画的画风和故事，这个网站满足了我所有的需求。界面清爽没有乱七八糟的广告，阅读体验非常舒适。',
    date: '2026-07-18',
  },
  {
    id: 6,
    name: '月光小筑',
    avatar: '',
    rating: 5,
    comment: '更新速度真的没话说，基本上韩国那边连载一出这边就有了。翻译质量也在线，不会出现看不懂的情况。已经推荐给身边所有追漫的朋友了。',
    date: '2026-07-15',
  },
];